import css from './login.module.scss';

import { memo, useCallback, useState } from 'react';

import { apiLogin } from 'core/api';
import usePromiseQuery from 'core/helpers/usePromiseQuery';
import { getFavIconUrl } from 'core/paths';
import { ErrorPane } from 'core/ui/Error';

import { Input, SubmitButton } from './controls';

const LoginForm = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<TAnyError | null>(null);

  const [doLogin, isFetching] = usePromiseQuery(
    useCallback(
      (evt: React.FormEvent<HTMLFormElement>): Promise<void> => {
        evt.preventDefault();
        return apiLogin(login, password)
          .then(() => {
            location.replace('/');
          })
          .catch(setError);
      },
      [login, password]
    )
  );

  return (
    <div className={css.root}>
      <img className={css.logo} src={getFavIconUrl()} />
      <form className={css.form} onSubmit={evt => void doLogin(evt)}>
        <Input
          type="text"
          value={login}
          placeholder="Login"
          onChange={evt => setLogin(evt.target.value)}
        />
        <Input
          type="password"
          value={password}
          placeholder="Password"
          onChange={evt => setPassword(evt.target.value)}
        />
        {error && <ErrorPane error={error} />}
        <SubmitButton isLoading={isFetching} />
      </form>
    </div>
  );
};

export default memo(LoginForm);
